import { Outlet } from "react-router-dom";

const Internet = () => {
  return (
    <div className="bg-white">
      <Outlet />
    </div>
  );
};

export default Internet;
